import {
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography
} from "@material-ui/core";
import {
  ArrowDownward,
  ArrowUpward,
  DashboardOutlined,
  MoneyOffOutlined,
  MoneyOutlined,
  Person,
  ShoppingCart
} from "@material-ui/icons";
import { SimpleKpiProps } from "./types";
import useStyles from "./styles";
import useModuleStyles from "../../styles";
import { useTheme } from "@material-ui/core/styles";
import React from "react";
import { PercentOutlined } from "@mui/icons-material";
import { Currency } from "../../../../components/misc/Currency";
import { InclVat } from "../inclVat";

export const KPI = (kpiProps: SimpleKpiProps) => {
  const theme = useTheme();
  const classes = useStyles();
  const moduleClasses = useModuleStyles();

  return (
    <Card style={{ height: "100%", position: "relative" }}>
      {!kpiProps.isLoading ? (
        <></>
      ) : (
        <div className={moduleClasses.spinnerContainer}>
          <CircularProgress />
        </div>
      )}
      <CardContent>
        <Grid justifyContent={"space-between"} container>
          <Grid item>
            <Typography color="textPrimary" gutterBottom variant="button">
              {kpiProps.title}
            </Typography>
            <Typography color="textPrimary" variant="h5">
              {kpiProps.value}
            </Typography>
          </Grid>
          <Grid item className={classes.avatar}>
            {kpiProps.avatar ? (
              kpiProps.avatar
            ) : (
              <Avatar
                style={{
                  backgroundColor: `${theme.palette.primary.main}`
                }}
              >
                <DashboardOutlined fontSize={"small"} />
              </Avatar>
            )}
          </Grid>
        </Grid>
        {kpiProps.showTrend && (
          <Box
            sx={{
              pt: 3,
              display: "flex",
              alignItems: "center"
            }}
          >
            {kpiProps.trendValue < 0 ? (
              <ArrowDownward className={classes.error} />
            ) : (
              <ArrowUpward className={classes.success} />
            )}
            <Typography
              style={{
                marginRight: 2,
                color: `${
                  kpiProps?.trendValue < 0
                    ? theme.palette.error.main
                    : theme.palette.success.main
                }`
              }}
              variant="body2"
            >
              {Math.abs(kpiProps.trendValue)}%
            </Typography>
            <Typography
              style={{ marginLeft: 3 }}
              color="textSecondary"
              variant="caption"
            >
              {kpiProps.trendText}
            </Typography>
          </Box>
        )}

        {kpiProps.showInclVatLabel && <InclVat />}
      </CardContent>
    </Card>
  );
};

export const VisitorsKpi = (kpiProps: SimpleKpiProps) => {
  const theme = useTheme();
  return (
    <KPI
      {...kpiProps}
      avatar={
        <Avatar
          style={{
            backgroundColor: `${theme.palette.error.dark}`
          }}
        >
          <Person fontSize={"large"} />
        </Avatar>
      }
    />
  );
};

export const PurchasesKpi = (kpiProps: SimpleKpiProps) => {
  const theme = useTheme();

  return (
    <KPI
      {...kpiProps}
      avatar={
        <Avatar
          style={{
            backgroundColor: `${theme.palette.success.dark}`
          }}
        >
          <ShoppingCart fontSize={"large"} />
        </Avatar>
      }
    />
  );
};

export const RefundsKpi = (kpiProps: SimpleKpiProps) => {
  const theme = useTheme();

  return (
    <KPI
      {...kpiProps}
      avatar={
        <Avatar
          style={{
            backgroundColor: `${theme.palette.primary.dark}`
          }}
        >
          <MoneyOffOutlined fontSize={"large"} />
        </Avatar>
      }
    />
  );
};

export const TotalSalesKpi = (kpiProps: SimpleKpiProps) => {
  const theme = useTheme();
  const props = {
    ...kpiProps,
    value: <Currency value={parseInt(kpiProps.value)} noDecimals />,
    showInclVatLabel: true
  };

  return (
    <KPI
      {...props}
      avatar={
        <Avatar
          style={{
            backgroundColor: `${theme.palette.success.dark}`
          }}
        >
          <MoneyOutlined fontSize={"large"} />
        </Avatar>
      }
    />
  );
};

export const ConversionRateKpi = (kpiProps: SimpleKpiProps) => {
  const theme = useTheme();

  return (
    <KPI
      {...kpiProps}
      avatar={
        <Avatar
          style={{
            backgroundColor: `${theme.palette.primary.dark}`
          }}
        >
          <PercentOutlined fontSize={"large"} />
        </Avatar>
      }
    />
  );
};
